module.exports = __webpack_public_path__ + "img/首页2-2-hover.d13226fd.svg";